import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class AssignSubscriptionService {
  static getCompanyList(key='') {
    return HttpUtil.get(API_ROUTES.ASSIGNSUBSCRIPTION.COMPANYLISTAPI.replace("<key>", key));
  }

  static getPlans() {
    return HttpUtil.get(API_ROUTES.ASSIGNSUBSCRIPTION.PLANS);
  }

  static onSubmit(planId,params) {
    var url = API_ROUTES.ASSIGNSUBSCRIPTION.SUBMIT.replace("<planId>", planId);
    return HttpUtil.patch(url,params);    
  } 
}